import { LoadingOutlined } from "@ant-design/icons";
import { TextField } from "@mui/material";
import { Form, FormInstance, Spin } from "antd";
import { useEffect, useRef } from "react";
import { ProductParams } from "../../../data/parser";
export type ProductSuggestion = ProductParams & { url: string };

interface Params {
  isLoading: boolean;
  onSubmit: (url: string) => Promise<void>;
  form: FormInstance;
}

export default function UrlForm({ isLoading, onSubmit, form }: Params) {
  const inputRef = useRef(null);

  useEffect(() => {
    (inputRef.current as HTMLInputElement | null)?.focus();
  });

  const onFinish = async (vals: Record<string, string>) => {
    await onSubmit(vals["url"]);
  };

  return (
    <Form
      form={form}
      name="item-edit"
      onFinish={onFinish}
      className="py-6! flex flex-col items-center gap-2.5"
      preserve={false}
      clearOnDestroy={true}
    >
      {isLoading ? (
        <Spin
          className="h-16 text-display-large"
          indicator={<LoadingOutlined spin className="block" />}
        />
      ) : (
        <div className="leading-16 text-display-large">😌</div>
      )}
      <Form.Item
        name="url"
        rules={[{ required: true, message: "Please provide a link or a name" }]}
      >
        <TextField
          label="Wish name or URL"
          variant="outlined"
          fullWidth
          disabled={isLoading}
          className="w-86!"
          inputProps={{ ref: inputRef }}
          helperText="Add a new item to your wishlist. Copy-paste the product URL, or type the product name."
        />
      </Form.Item>
    </Form>
  );
}
